import React, { useState } from 'react';
import { ErrorPage } from '@src/shared/ui';
import {
  useNavigationHandlers,
  useProposalState,
  useGTM,
} from '@src/shared/hooks';
import {
  getProposal,
  retryCheckProposal,
  setProposal,
} from '@src/shared/zustand';
import { CheckProposalStatus } from '@src/shared/models';
import { goToByError } from '@src/shared';
import { GTMEvents } from '@src/config/gtm';

export const IdwallTimeoutPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { trackEvent } = useGTM();
  const { proposal } = useProposalState();

  const navigationHandlers = useNavigationHandlers();

  const handleRetry = () => {
    setLoading(true);
    trackEvent(GTMEvents.IDWALL_RETRY, {
      proposal_id: proposal.proposalId,
    });

    retryCheckProposal(proposal.proposalId, async (error, status) => {
      setLoading(false);

      if (error) {
        goToByError(error, navigationHandlers);
        return;
      }

      switch (status) {
        case CheckProposalStatus.PENDING:
          setProposal(null, () => {
            navigationHandlers.toHome();
          });

          break;
        case CheckProposalStatus.APPROVED:
          getProposal(proposal.proposalId, (error) => {
            if (error) {
              goToByError(error, navigationHandlers);

              return;
            }

            navigationHandlers.toHome();
          });

          return;
        case CheckProposalStatus.REJECTED:
        default:
          navigationHandlers.toReprovedByIdwall();
          break;
      }
    });
  };

  return (
    <ErrorPage
      title='Ops, algo deu errado'
      description='Não conseguimos concluir sua solicitação no momento. Por favor, tente novamente ou refaça o seu parcelamento daqui a alguns minutos.'
      backToGolButtonPrimary={false}
      primaryButton={{
        onClick: handleRetry,
        text: 'Tentar novamente',
        loading,
      }}
    />
  );
};
